import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import getLocale from '../../../i18n/getLocale';

// Importo o moment com a linguagem pt-br
require('moment');
require('moment/locale/pt-br');

class TrainingsEditTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      id: this.props.training_id,
      name: this.props.training_data.name,
      date_start_str: this.props.training_data.date_start_str,
      date_finish_str: this.props.training_data.date_finish_str,
      code: this.props.training_data.code,
      revision: this.props.training_data.revision,
      observations: this.props.training_data.observations,
    };

    this.locale = getLocale();

    //bind específico
    this.edit = this.edit.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleChangeDatePicker (state, date) {
    var change = {};
    change[state] = date.format("DD/MM/YYYY");
    this.setState(change);
  } 


  // LM
  componentWillReceiveProps(newProps) {
    if(typeof this.state.name === 'undefined' && typeof newProps.training_data.name !== 'undefined') {
      this.setState({
        id: newProps.training_id,
        name: newProps.training_data.name,
        date_start_str: newProps.training_data.date_start_str,
        date_finish_str: newProps.training_data.date_finish_str,
        code: newProps.training_data.code,
        revision: newProps.training_data.revision,
        observations: newProps.training_data.observations,
      });
    }
  }
  
  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      date_start: this.state.date_start_str,
      date_finish: this.state.date_finish_str,
      observations: this.state.observations,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <form onSubmit={this.edit}> 
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.DataDeInicio}:</label>
          <InputMask value={this.state.date_start_str}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start_str')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.placeholder.DataDeInicio} />
        </div>
      </div>
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.DataDeTermino}:</label>
          <InputMask value={this.state.date_finish_str}  maskChar={null} name="date_finish_str " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish_str')} placeholder={this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.placeholder.DataDeTermino} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.Nome}:</label>
          <input type="text" name="name" className="form-control" placeholder={this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.placeholder.NomeDoTreinamento} value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
        </div>
      </div>
      <div className="col-md-3" style={{marginTop: '20px'}}>
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.Codigo}:</label><br/>
          {this.state.code}
        </div>
      </div>
      <div className="col-md-3" style={{marginTop: '20px'}}>
        <div className="form-group">
        
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.Revisao}:</label><br/>
          {this.state.revision}
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-6">
        <div className="form-group">
          <label>{this.locale.Treinamentos.EditarTreinamento.tabDadosDoTreinamento.formulario.Observacoes}:</label>
          <textarea style={{ height: 100 }} type="text" name="observations" className="form-control" value={this.state.observations} onChange={this.handleChange.bind(this, 'observations')} />
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-md-12">
        <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.general.salvarEdicao}</button>
      </div>
    </div>
  </form>
</div>
    );
  }
}

export default TrainingsEditTab;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingsEditTab.js